import React from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Form,
  FormGroup
} from 'reactstrap'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'

const MessageModal = React.memo(
  ({ isOpen, toggle, className, onSubmit, storeName, intl }) => {
    let emailInput = {}
    let subjectInput = {}
    let messageInput = {}

    return (
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className={`${className} report-modal`}
        size='lg'
      >
        <Form name='contact'>
          <ModalHeader toggle={toggle}>
            <FormattedMessage id='store.actions.message.contact' />{' '}
            <span className='font-weight-normal'>{storeName}</span>
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Input
                rows='4'
                type='text'
                name='email'
                id='email'
                placeholder={intl.formatMessage({
                  id: 'store.actions.message.yourEmail'
                })}
                innerRef={input => {
                  emailInput = input
                }}
                required
              />
            </FormGroup>
            <FormGroup>
              <Input
                rows='4'
                type='text'
                name='message'
                id='message'
                placeholder={intl.formatMessage({
                  id: 'store.actions.message.subject'
                })}
                innerRef={input => {
                  subjectInput = input
                }}
                required
              />
            </FormGroup>
            <FormGroup>
              <Input
                rows='4'
                type='textarea'
                name='message'
                id='message'
                placeholder={intl.formatMessage({
                  id: 'store.actions.message.message'
                })}
                innerRef={input => {
                  messageInput = input
                }}
                required
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color='black'
              className='order-1 order-md-0'
              outline
              onClick={toggle}
            >
              <FormattedMessage id='general.modalClose' />
            </Button>{' '}
            <Button
              color='primary'
              className='order-0 order-md-1 mb-3 mb-md-0'
              onClick={e =>
                onSubmit({
                  email: emailInput.value,
                  subject: subjectInput.value,
                  message: messageInput.value
                })
              }
            >
              <FormattedMessage id='store.actions.message.sendMessage' />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
)

MessageModal.displayName = 'MessageModal'

MessageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  storeName: PropTypes.string,
  intl: PropTypes.object.isRequired
}

export default injectIntl(MessageModal)
